class SwiperHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll(':scope > .swiper-hero__viewport > .swiper-hero__track > slideshow-slide'));
    this.dots = Array.from(this.querySelectorAll('[data-swiper-hero-dot]'));
    this.previousButton = this.querySelector('[data-swiper-hero-previous]');
    this.nextButton = this.querySelector('[data-swiper-hero-next]');
    this.index = Math.max(0, this.slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false'));
    this.loop = this.dataset.loop === 'true';
    this.autoplayDelay = Number(this.dataset.autoplay) * 1000;

    this.previousButton?.addEventListener('click', this.previous);
    this.nextButton?.addEventListener('click', this.next);
    this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
    this.addEventListener('pointerdown', this.onPointerDown);
    this.addEventListener('pointerup', this.onPointerUp);
    this.addEventListener('mouseenter', this.pause);
    this.addEventListener('mouseleave', this.start);
    this.addEventListener('focusin', this.pause);
    this.addEventListener('focusout', this.start);
    document.addEventListener('shopify:block:select', this.onBlockSelect);

    this.show(this.index, false);
    this.start();
  }

  disconnectedCallback() {
    this.previousButton?.removeEventListener('click', this.previous);
    this.nextButton?.removeEventListener('click', this.next);
    this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
    this.removeEventListener('pointerdown', this.onPointerDown);
    this.removeEventListener('pointerup', this.onPointerUp);
    this.removeEventListener('mouseenter', this.pause);
    this.removeEventListener('mouseleave', this.start);
    this.removeEventListener('focusin', this.pause);
    this.removeEventListener('focusout', this.start);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    this.pause();
  }

  previous = () => this.goTo(this.index - 1);
  next = () => this.goTo(this.index + 1);

  onDotClick = (event) => {
    this.goTo(Number(event.currentTarget.dataset.swiperHeroDot));
  };

  onPointerDown = (event) => {
    this.pointerStart = event.clientX;
  };

  onPointerUp = (event) => {
    if (this.pointerStart == null) return;
    const distance = event.clientX - this.pointerStart;
    this.pointerStart = null;
    if (Math.abs(distance) < 50) return;
    distance < 0 ? this.next() : this.previous();
  };

  onBlockSelect = (event) => {
    const slide = event.target.closest('slideshow-slide');
    if (!slide || !this.contains(slide)) return;
    const index = this.slides.indexOf(slide);
    if (index >= 0) {
      this.pause();
      this.show(index);
    }
  };

  goTo(index) {
    if (this.slides.length < 2) return;
    if (this.loop) {
      index = (index + this.slides.length) % this.slides.length;
    } else {
      index = Math.min(Math.max(index, 0), this.slides.length - 1);
    }
    this.show(index);
    this.start();
  }

  show(index, animate = true) {
    this.index = index;
    this.toggleAttribute('data-no-animation', !animate);
    this.style.setProperty('--swiper-hero-index', index);

    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.classList.toggle('swiper-hero__slide--active', active);
      slide.setAttribute('aria-hidden', String(!active));
      if (active) slide.removeAttribute('inert');
      else slide.setAttribute('inert', '');
    });

    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (!this.loop) {
      if (this.previousButton) this.previousButton.disabled = index === 0;
      if (this.nextButton) this.nextButton.disabled = index === this.slides.length - 1;
    }

    requestAnimationFrame(() => this.removeAttribute('data-no-animation'));
  }

  start = () => {
    this.pause();
    if (!this.autoplayDelay || this.slides.length < 2 || window.Shopify?.designMode) return;
    this.timer = window.setInterval(this.next, this.autoplayDelay);
  };

  pause = () => {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = undefined;
  };
}

if (!customElements.get('swiper-hero')) {
  customElements.define('swiper-hero', SwiperHero);
}
